import React, { useState } from "react"
import useApi from "../../hooks/useApi.js"

export default function CreateShopStep({ t, onCreated }) {
  const api = useApi()
  const [ name, setName ] = useState("")
  const [ url, setUrl ] = useState("")
  const [ submitting, setSubmitting ] = useState(false)
  const [ errors, setErrors ] = useState([])

  const submit = async (e) => {
    e.preventDefault()
    setSubmitting(true)
    setErrors([])
    try {
      await api.post("/api/v1/shop", { shop: { name, url } })
      onCreated()
    } catch (err) {
      setErrors([ err.message ])
      setSubmitting(false)
    }
  }

  return (
    <form onSubmit={submit} className="space-y-6">
      <div>
        <h1 className="text-[28px] font-medium tracking-[-0.035em] text-ink-primary">
          {t("dashboard.onboarding.create.title")}
        </h1>
        <p className="mt-2 text-sm text-ink-secondary leading-relaxed">
          {t("dashboard.onboarding.create.lede")}
        </p>
      </div>

      <div className="space-y-4">
        <label className="block">
          <span className="font-mono text-[10px] tracking-[0.12em] text-ink-tertiary">
            {t("dashboard.onboarding.create.name_label").toUpperCase()}
          </span>
          <input
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("dashboard.onboarding.create.name_placeholder")}
            className="mt-1 w-full bg-surface-card border border-rule rounded-button px-3 py-2 text-sm text-ink-primary placeholder:text-ink-faint focus:outline-none focus:border-brand"
          />
        </label>

        <label className="block">
          <span className="font-mono text-[10px] tracking-[0.12em] text-ink-tertiary">
            {t("dashboard.onboarding.create.url_label").toUpperCase()}
          </span>
          <input
            type="url"
            required
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder={t("dashboard.onboarding.create.url_placeholder")}
            className="mt-1 w-full bg-surface-card border border-rule rounded-button px-3 py-2 text-sm text-ink-primary placeholder:text-ink-faint focus:outline-none focus:border-brand"
          />
        </label>
      </div>

      {errors.length > 0 && (
        <ul className="text-sm text-failure space-y-1">
          {errors.map((msg, i) => <li key={i}>{msg}</li>)}
        </ul>
      )}

      <button
        type="submit"
        disabled={submitting}
        className="bg-brand text-ink-on-dark rounded-button px-4 py-2 text-[13px] font-medium disabled:opacity-60"
      >
        {submitting
          ? t("dashboard.onboarding.create.submitting")
          : t("dashboard.onboarding.create.submit")}
      </button>
    </form>
  )
}
